<template>
  <b-modal
    id="apply-bet-promo-modal"
    hide-footer
    size="md"
    centered
    dialog-class="promo-modal"
    @hide="hideModal"
  >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <span class="font-weight-bold">Apply Bet Promo</span>
      </div>
    </template>

    <div class="text-center mb-1">
      <h5 class="font-weight-bold">Select Bet Promo</h5>
      <small class="text-muted">
        Choose from available bet promo templates to apply.
      </small>
    </div>

    <div class="text-black d-flex">
      <label class="mb-1 mr-2">Type</label>
      <b-form-radio-group
        id="type"
        v-model="type"
        :options="optionsType"
        name="type"
      />
    </div>

    <!-- Bet Promo -->
    <b-form-group label="Bet Promo" class="text-black">
      <b-form-select v-model="option" :options="options"> </b-form-select>
    </b-form-group>

    <!-- Description -->
    <b-form-group label="Description" class="text-black">
      <b-form-textarea
        v-model="description"
        placeholder="Description will appear after bet promo selected"
        rows="3"
        class="rounded-lg promo-description"
        disabled
      />
    </b-form-group>

    <!-- Buttons -->
    <b-button
      :disabled="loadingCreatePromotion || !option"
      @click="handleApplyPromotion"
      block
      variant="success"
      class="mb-1 mt-2"
    >
      <Spinner v-if="loadingCreatePromotion" />
      <template v-else> APPLY BET PROMO</template>
    </b-button>

    <b-button block variant="primary" class="mb-1" @click="handleRedirect"> CREATE BET PROMO </b-button>

    <b-button block variant="outline-secondary" @click="hideModal"> CANCEL </b-button>
  </b-modal>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import useToastHandler from "@/services/toastHandler";
import {
  BButton,
  BModal,
  BFormGroup,
  BFormSelect,
  BFormSelectOption,
  BFormTextarea,
  BFormRadioGroup,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BFormTextarea,
    BFormRadioGroup,
    Spinner
  },
  data() {
    const options = [{ value: null, text: "Select Bet Promo" }];
    return {
      option: options[0].value,
      description: "",
      type: "Price",
      options,
      optionsType: [
        { text: "Price Promotion", value: "Price" },
        { text: "Money Back Specials", value: "Money Back Specials" },
      ],
    };
  },
  watch: {
    option(val) {
      if (val) {
        const item = this.options.find((i) => i.id === val);
        this.description = item.description;
      }
    },
    type() {
      this.option = null;
      this.fetchPromotionList();
    },
  },
  async created() {
    await this.fetchPromotionList();
  },
  computed: {
    ...mapState("promotions/list", ["loadingCreatePromotion"]),
  },
  methods: {
    ...mapActions({
      getPromotionsList: "promotions/list/getPromotionsList",
      getDetailPromotion: "promotions/list/getDetailPromotion",
      updatePromotionTargets: "promotions/list/updatePromotionTargets",
      createNewPromotion: "promotions/list/createNewPromotion",
      fetchUser: "user/detail/asyncUser",
    }),
    async fetchPromotionList() {
      const data = await this.getPromotionsList({
        page: 1,
        limit: 100,
        type: this.type,
        onlyActive: true,
      });

      if (!data)
        return this.showToastError(false, "Error fetching promotion list");
      const list = data.data.map((i) => {
        return {
          ...i,
          value: i.id,
          text: i.name,
        };
      });
      this.options = [{ value: null, text: "Select Promotion" }, ...list];
    },
    async handleApplyPromotion() {
      const res = await this.updatePromotionTargets({
        promotionId: this.option,
        targets: [
          {
            targetType: "User",
            targetId: this.$router.currentRoute.params.id,
          },
        ],
      });
      if (res) {
        this.showToastSuccess(true, "Applied successfully!");
        this.hideModal();
        this.fetchUser({ id: this.$router.currentRoute.params.id });
      }
    },
    hideModal() {
      this.$bvModal.hide("apply-bet-promo-modal");
      this.option = null;
      this.description = "";
      this.type = null;
    },
    handleRedirect() {
      if (this.type === 'Money Back Specials') {
        return this.$router.push(`/promotions/money-back-specials/${this.$router.currentRoute.params.id}/new`);
      }
       if (this.type === 'Price') {
        return this.$router.push(`/promotions/price-promotions/${this.$router.currentRoute.params.id}/new`);
      }
    }
  },
   setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>
